import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map, catchError, throwError } from 'rxjs';

type GenerateResponse = { resume: string };

@Injectable({ providedIn: 'root' })
export class ResumeBuilderService {
  // Cloud Run base URL
  private readonly baseUrl = 'https://resume-generator-630346558823.us-central1.run.app';

  constructor(private http: HttpClient) {}

  generateResume(currentResume: string, jobDescription: string) {
    const url = `${this.baseUrl}/generate`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = {
      current_resume: currentResume,
      job_description: jobDescription
    };

    return this.http.post<GenerateResponse>(url, body, { headers }).pipe(
      map((r) => (r?.resume || '').trim()),
      catchError((err: HttpErrorResponse) => {
        // status 0 = CORS/network/preflight blocked or DNS/SSL issues
        if (err.status === 0) {
          return throwError(
            () =>
              new Error(
                'Network/CORS error: Cloud Run did not allow the browser request. Ensure /generate responds to OPTIONS and sends Access-Control-Allow-Origin for http://localhost:4200.'
              )
          );
        }

        const serverMsg =
          (err.error && (err.error.details || err.error.error)) ||
          err.message ||
          'Request failed';

        return throwError(() => new Error(serverMsg));
      })
    );
  }
}
